module.exports = __webpack_public_path__ + "img/drops.7b5923ff.png";